import store from "../../index.js";
import InsuranceConstant, {
  initialRegisterState,
  initialItemState,
  initialMetaState,
} from "@/mixins/insurance/const/insuranceConstant.js";
import InsuranceAcConstant from "@/mixins/insurance/const/insuranceAcConstant.js";

import { callGetApi, callPostApi, callPatchApi } from "@/utils/apiWrapper";

export const modules = {
  store,
};

export const state = {
  _insurance_type: {},
  _meta: { ...initialMetaState },
  _item: { ...initialItemState },
  _register: { ...initialRegisterState },
  _register_date: {
    start_date: "",
    end_date: "",
  },
  _order: {
    // amount: 0,
    isFreeMonth: false,
    one_time: {
      totalPrice: 0,
      taxFreeAmount: 0,
      taxableAmount: 0,
      vatAmount: 0,
    },
    monthly: {
      totalPrice: 0,
      taxFreeAmount: 0,
      taxableAmount: 0,
      vatAmount: 0,
    },
    discountInfo: {
      convertedPrice: 0,
      discountRate: 0,
    },
  },
  _error: {
    code: 0,
    message: "",
  },
};

export const mutations = {
  // 보험 상세
  [InsuranceConstant.SET_INSURANCE_ITEM](state, item) {
    state._item = item;
  },
  [InsuranceConstant.SET_INSURANCE_TYPE](state, item) {
    state._insurance_type = item;
  },

  // 보험 등록 정보
  [InsuranceConstant.SET_INSURANCE_REGISTER](state, item) {
    Object.keys(item).forEach(key => {
      if (key in state._register) {
        state._register[key] = item[key];
      }
    });
  },
  [InsuranceConstant.SET_INSURANCE_REGISTER_DATE](state, item) {
    state._register_date.start_date = item.start_date;
    state._register_date.end_date = item.end_date;
  },
  [InsuranceConstant.SET_INSURANCE_RESET_REGISTER](state) {
    state._register = { ...initialRegisterState };
  },

  // 메타 정보
  [InsuranceConstant.SET_INSURANCE_META](state, item) {
    Object.keys(item).forEach(key => {
      if (key in state._meta) {
        state._meta[key] = item[key];
      }
    });
  },

  // 금액 정보
  [InsuranceConstant.SET_INSURANCE_AMOUNT](state, item) {
    state._order = item;
  },

  // 에러 처리
  [InsuranceConstant.SET_INSURANCE_ERROR](state, item) {
    state._error = item;
  },
};

export const actions = {
  async acInsuranceDetail({ commit }, id) {
    const res = await callGetApi({
      url: `${InsuranceAcConstant.GET_INSURANCE_DETAIL}/${id}`,
      params: {},
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });

    if (!res) return false;

    commit(InsuranceConstant.SET_INSURANCE_ITEM, res);
    return true;
  },

  async acInsuranceDetailByMerchantUid({ commit }, merchant_uid) {
    const res = await callGetApi({
      url: `${InsuranceAcConstant.GET_INSURANCE_DETAIL_BY_MID}/${merchant_uid}`,
      params: {},
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });

    if (!res) return false;

    commit(InsuranceConstant.SET_INSURANCE_ITEM, res);
    return true;
  },

  async acInsuranceStatus({ commit }) {
    return await callGetApi({
      url: InsuranceAcConstant.GET_INSURANCE_STATUS,
      params: {},
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });
  },

  async acInsuranceAmount({ commit }, payload) {
    const res = await callGetApi({
      url: `${InsuranceAcConstant.GET_DEPOSIT_AMOUNT}/${payload.insurance_type}`,
      params: {
        deposit: payload.deposit,
        report_seq: payload.report_seq,
        subscribe_seq: payload.subscribe_seq,
      },
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });

    if (!res) return false;

    commit(InsuranceConstant.SET_INSURANCE_AMOUNT, res);
    return true;
  },

  async acInsuranceValidDate({ commit }, payload) {
    const res = await callGetApi({
      url: `${InsuranceAcConstant.GET_VALID_DATE}/${payload.insurance_type}`,
      params: { date: payload.date },
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });

    return res?.isValidDate ?? false;
  },

  async acInsuranceContractUpdate({ commit }, payload) {
    const res = await callPatchApi({
      url: `${InsuranceAcConstant.PATCH_INSURANCE_CONTRACT_UPDATE}/${payload.id}`,
      data: { ...payload.items },
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });
    return !!res;
  },

  async acPaypleInfo({ commit }, { insurance_type, payment_type }) {
    return await callGetApi({
      url: InsuranceAcConstant.GET_PAYPLE_INFO,
      params: { insurance_type, payment_type },
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });
  },

  async acPaymentInit({ commit }, payload) {
    const res = await callPostApi({
      url: InsuranceAcConstant.POST_INSURANCE_PAYMENT_INIT,
      data: { ...payload },
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });
    return !!res;
  },

  // [로컬 테스트 전용] 결제 웹훅 대체 — pending 주문 완료 처리. prod 빌드엔 호출부(버튼)가 없고 BE도 prod 차단.
  async acTestCompletePayment({ commit }, payload) {
    const res = await callPostApi({
      url: InsuranceAcConstant.POST_INSURANCE_TEST_PAYMENT_COMPLETE,
      data: { ...payload },
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });
    return !!res;
  },

  async acInsuranceDocument({ commit }, payload) {
    return await callGetApi({
      url: InsuranceAcConstant.GET_INSURANCE_DOCUMENT,
      params: {
        document_type: payload.document_type,
        insurance_type: payload.insurance_type,
      },
      commit,
      errorMutation: InsuranceConstant.SET_INSURANCE_ERROR,
    });
  },
};

export const getters = {
  // 보험 상세(_item) — FA 완료화면 가입자 정보 보강(fnFillFromDetail)에서 참조.
  _item: state => state._item,
  geCodeFail: state => {
    switch (state._error.code) {
      case 0:
        return "";
      case 6101:
        return "가입할 대상의 구독이 없습니다.";
      case 6102:
        return "주소 데이터가 없습니다.";
      case 6300:
        return "본인인증 결과가 없습니다. 다시 시도해주세요.";
      case 6301:
        return "본인인증 결과가 없습니다. 다시 시도해주세요.";
      case 6302:
        return "본인인증 결과가 없습니다. 다시 시도해주세요.";
      case 6303:
        return "인증 유효시간이 만료 되었습니다.";
      default:
        return state._error.message;
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
